import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';

const HoverTooltip = ({ title, children }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  if (!title) {
    return <>{children}</>;
  }

  const show = () => {
    if (!triggerRef.current) {
      return;
    }
    const rect = triggerRef.current.getBoundingClientRect();
    setPosition({
      top: rect.top,
      left: rect.left + rect.width / 2
    });
    setVisible(true);
  };

  const hide = () => setVisible(false);

  return (
    <span
      ref={triggerRef}
      className="tooltip-trigger"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      {children}
      {visible && createPortal(
        <span
          role="tooltip"
          className="tooltip-bubble"
          style={{ top: position.top, left: position.left }}
        >
          {title}
        </span>,
        document.body
      )}
    </span>
  );
};

export default HoverTooltip;
